import { Pipe, PipeTransform } from '@angular/core';
import { Match } from '../match.model';
import { IsPreMatchOnlyPipe } from './is-pre-match-only.pipe';

/**
 * A pipe which transforms a [`Match`](../match.model.ts)
 * object into a boolean, representing whether the match has finished, and the match's
 * sport is supported for live updates on this client (verified by using the [`IsPreMatchOnlyPipe`](./is-pre-match-only.pipe.ts)).
 */
@Pipe({
  name: 'isOver',
  pure: false,
})
export class IsOverPipe implements PipeTransform {

  constructor(
    private isPreMatchOnlyPipe: IsPreMatchOnlyPipe
  ) { }

  /**
	 * A pipe which transforms a [`Match`](../match.model.ts)
	 * object into a boolean, representing whether the match has finished, and the match's
   * sport is supported for live updates on this client (verified by using the [`IsPreMatchOnlyPipe`](./is-pre-match-only.pipe.ts)).
	 * @param match the `Match` object for the sporting match
	 * @returns `true` if the match's live data indicates that the match is over, and the `IsPreMatchOnlyPipe` transforms `match` into
   * `false`; `false` if either of those conditions is not met.
	 */
  transform(match: Match): boolean {
    /** Match statuses which indicate that a match is over are `completed`, `ended` and `retirement` */
    return this && match.LiveData 
			&& (match.LiveData.status === "completed" || match.LiveData.status === "ended" || match.LiveData.status === "retirement")
			&& !this.isPreMatchOnlyPipe.transform(match);
  }

}
